import React from 'react'
import {useAuth} from '../../../../app/modules/auth'
import {UspsStripeBanner} from './UspsStripeBanner'
import {BaeGuardStripeBanner} from './BaeGuardStripeBanner'

// Global promo stripe stack (USPS / BaeGuard). MasterLayout renders this only
// when the email-verification TopAlert is NOT shown — the email banner takes
// priority so the two never stack. Height is measured on MasterLayout's wrapper.
const GlobalBannerStack: React.FC = () => {
  const {currentUser} = useAuth()
  if (!currentUser) return null

  return (
    <>
      <UspsStripeBanner />
      <BaeGuardStripeBanner />
    </>
  )
}

export {GlobalBannerStack}
